import React from 'react';
import ErrorHandleView from '@components/ErrorHandleView';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log(
      'Debug ~ file: index.js:10 ~ ErrorBoundary ~ getDerivedStateFromError ~ error:',
      error
    );
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(
      'Debug ~ file: index.js:19 ~ ErrorBoundary ~ componentDidCatch ~ error:',
      error
    );
    console.log(
      'Debug ~ file: index.js:23 ~ ErrorBoundary ~ componentDidCatch ~ errorInfo:',
      errorInfo
    );
  }

  render() {
    if (this.state.hasError) {
      return <ErrorHandleView />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
